import Language from '@/contexts/language/locales/en';
import LogoNSPharmacy from '@/assets/images/pharmacies/ico048.svg';
import WatsonsPharmacy from '@/assets/images/pharmacies/img004.png';
import HiPresPharmacy from '@/assets/images/pharmacies/img005.png';
import MedexPharmacy from '@/assets/images/pharmacies/img006.png';

export const STATUS_CODES = {
  FAILED: -99,
  EXPIRED: -10,
  OUTOFSTOCK: -7,
  CANCELLED: -6,
  FAILED_PAYMENT: -5,
  FAILED_DELIVERY: -4,
  AREA_NOT_SERVICEABLE: -3,
  CONTACT_CANCELLATION: -2,
  FAILED_TO_CONTACT: -1,
  PENDING: 1,
  PROCESSING: 2,
  FOR_FOLLOW_UP: 3,
  CONFIRMED: 4,
  DELIVERING: 5,
  FULFILLED: 6,
  PROC_FAILED_DELIVERY: 7,
  AWAITING_PAYMENT: 8,
  ALL: 99,
};

export const MEDICINE_ONGOING_STATUS_CODES = [
  STATUS_CODES.PROC_FAILED_DELIVERY,
  STATUS_CODES.PENDING,
  STATUS_CODES.FOR_FOLLOW_UP,
  STATUS_CODES.CONFIRMED,
  STATUS_CODES.PROCESSING,
  STATUS_CODES.DELIVERING,
  STATUS_CODES.AWAITING_PAYMENT,
];

export const CANCELLED_STATUSES = [
  STATUS_CODES.EXPIRED,
  STATUS_CODES.OUTOFSTOCK,
  STATUS_CODES.CANCELLED,
  STATUS_CODES.FAILED_PAYMENT,
  STATUS_CODES.FAILED_DELIVERY,
  STATUS_CODES.AREA_NOT_SERVICEABLE,
  STATUS_CODES.CONTACT_CANCELLATION,
  STATUS_CODES.FAILED_TO_CONTACT,
];

export const DEFAULT_PHARMACIES = {
  NS_PHARMACY: 'nspharmacy',
  medex_live: 'medex_live',
  watsons: 'watsons',
  hipres: 'hipres',
  hipres_test: 'hipres_test',
  ssd: 'ssd',
  amplify: 'amplify',
};

export const AVAILMENT_CODES = {
  NSPH: 'NSPH',
};

export const COUPON_FULFILLMENT_MODE = {
  DELIVERY: 'delivery',
  PICKUP: 'pickup',
};

export const PARTNER_TYPES = {
  hmo: 'hmo',
  diagnostics: 'diagnostics',
  medicine: 'medicine',
  homeservicelabs: 'homeservicelabs',
};

export const MEDICINE_TITLES = {
  medicine: Language.methods.getText('txt070'),
  watsons: Language.methods.getText('txt070'),
  diagnostics: Language.methods.getText('txt031'),
};

export const MEDICINE_SUBTITLES = {
  medex: 'MedExpress',
  hipres_test: 'Hi-Precision Branch',
  [DEFAULT_PHARMACIES.NS_PHARMACY]: 'NowServing Pharmacy',
  [DEFAULT_PHARMACIES.medex_live]: 'MedExpress',
  [DEFAULT_PHARMACIES.watsons]: 'Watsons',
  [DEFAULT_PHARMACIES.hipres]: 'Hi-Precision Branch',
  [COUPON_FULFILLMENT_MODE.DELIVERY]: 'Watsons Delivery',
  [COUPON_FULFILLMENT_MODE.PICKUP]: 'Watsons Branch Pickup',
};

export const STATUS_CODES_TEXT = {
  [STATUS_CODES.OUTOFSTOCK]: 'Out of Stock',
  [STATUS_CODES.CANCELLED]: 'Cancelled',
  [STATUS_CODES.EXPIRED]: 'Order Expired',
  [STATUS_CODES.CONTACT_CANCELLATION]: 'Change of Mind',
  [STATUS_CODES.FAILED_DELIVERY]: 'Delivery Failed',
  [STATUS_CODES.PROC_FAILED_DELIVERY]: 'Delivery Failed',
  [STATUS_CODES.FAILED_PAYMENT]: 'Failed',
  [STATUS_CODES.FAILED_TO_CONTACT]: 'Unresponsive',
  [STATUS_CODES.AREA_NOT_SERVICEABLE]: 'Failed',
  [STATUS_CODES.PENDING]: 'Wait for a call',
  [STATUS_CODES.PROCESSING]: 'Processing',
  [STATUS_CODES.FOR_FOLLOW_UP]: 'For Follow-up',
  [STATUS_CODES.CONFIRMED]: 'Confirmed',
  [STATUS_CODES.AWAITING_PAYMENT]: 'Awaiting Payment',
  [STATUS_CODES.DELIVERING]: 'Shipped',
  [STATUS_CODES.FULFILLED]: 'Fulfilled',
};

export const ORDER_STATUS_NEEDS_PAYMENT = [
  STATUS_CODES.AWAITING_PAYMENT,
  STATUS_CODES.CONFIRMED,
];

export const ORDER_STATUS_CAN_CANCEL = [
  ...ORDER_STATUS_NEEDS_PAYMENT,
  STATUS_CODES.PENDING,
];

export const PARTNER_ICONS = {
  medex: MedexPharmacy,
  [DEFAULT_PHARMACIES.medex_live]: MedexPharmacy,
  [DEFAULT_PHARMACIES.NS_PHARMACY]: LogoNSPharmacy,
  nsPharmacy: LogoNSPharmacy,
  watsons: WatsonsPharmacy,
  hipres: HiPresPharmacy,
  hipres_test: HiPresPharmacy,
};

export const COUPON_NUMBER_OF_DAYS_AFTER_EXPIRY = 14;

export const PHARMACY_OPERATIONAL_HOURS_LABEL_ID = {
  [DEFAULT_PHARMACIES.NS_PHARMACY]: 'txt212',
  [DEFAULT_PHARMACIES.watsons]: 'txt143',
  [DEFAULT_PHARMACIES.medex_live]: 'txt141', 
};

export const GET_PHARMACY_SAME_DAY_DELIVERY_CUTOFF_LABEL_ID = (partnercode) => {
  return partnercode === DEFAULT_PHARMACIES.NS_PHARMACY
    ? 'txt217'
    : partnercode === DEFAULT_PHARMACIES.watsons
      ? 'txt144'
      : 'txt142';
};

export const ORDER_PAYMENTS = {
  paymaya: 'paymaya',
  cod: 'cod',
  gcash: 'gcash',
  credit: 'credit',
};

export const OrderPaymentTypesNames = {
  [ORDER_PAYMENTS.cod]: 'Cash on Delivery',
  [ORDER_PAYMENTS.gcash]: 'GCash',
  [ORDER_PAYMENTS.paymaya]: 'PayMaya',
  [ORDER_PAYMENTS.credit]: 'Credit Card',
};

export const COUPON_STATUS = {
  ISSUED: 'issued',
  AVAILED: 'availed',
  AVAILED_MAX: 'availed_max',
  ARCHIVED: 'archived',
};

export const REGINE_NUMBER = 'No number';
